var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Grid } from "semantic-ui-react";
import { AppPaths, marketingSiteShopPage, ShopLink, useMarketingSite } from "../AppConfig";
import { ORIGIN } from "../Config";
var NewKitPage = /** @class */ (function (_super) {
    __extends(NewKitPage, _super);
    function NewKitPage(props, context) {
        return _super.call(this, props, context) || this;
    }
    NewKitPage.prototype.componentDidMount = function () {
        if (useMarketingSite) {
            window.location.href = marketingSiteShopPage;
        }
    };
    NewKitPage.prototype.render = function () {
        return React.createElement(Grid, { columns: 3, id: "non-header-portion" },
            React.createElement(Grid.Row, null,
                ORIGIN === "mi" && React.createElement(Grid.Column, null,
                    React.createElement("div", { style: { textAlign: 'center' } },
                        React.createElement(ShopLink, { to: AppPaths.LOCAL_NEW_KIT_RNA_FISH }, "RNA-FISH"))),
                ORIGIN === "mi" && React.createElement(Grid.Column, null,
                    React.createElement("div", { style: { textAlign: 'center' } },
                        React.createElement(ShopLink, { to: AppPaths.LOCAL_NEW_KIT_IHC2 }, "HCR\u2122 2\u00BAIF"))),
                ORIGIN === "hcr" && React.createElement(Grid.Column, null,
                    React.createElement("div", { style: { textAlign: 'center' } },
                        React.createElement(ShopLink, { to: AppPaths.LOCAL_NEW_KIT_RNA_CISH }, "RNA-CISH")))));
    };
    return NewKitPage;
}(React.PureComponent));
export default NewKitPage;
//# sourceMappingURL=NewKitPage.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/NewKitPage.js
// module id = 1306
// module chunks = 0